const _jsxFileName = "/codebuild/output/src3182596400/src/codeconnections.ap-southeast-1.amazonaws.com/git-http/178309656639/ap-southeast-1/c294c899-f583-4463-ab85-039718732de9/suphachai2/mobileschool/ms-shared/src/components/frame/modal/search_popup.jsx"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React, { useEffect, useRef, useState } from "react";
import { AutoComplete } from "primereact/autocomplete";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { apiGetTagStat } from "../../../services/api/tag";
import { apiGetSearchUser } from "../../../services/api/user";
import { apiGetOwnGroupSocial } from "../../../services/api/group";

const SearchPopup = ({ hashtag, className = "" }) => {
    const { t } = useTranslation();
    const [value, setValue] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const userInfo = JSON.parse(localStorage.getItem("social_user_info"));
    const debounceRef = useRef();

    useEffect(() => {
        if (hashtag) {
            setValue(`#${hashtag}`);
        }
    }, [hashtag]);

    const search = async (event) => {
        const query = (event.query || "").toLowerCase();

        if (query.startsWith("#")) {
            const keyword = query.slice(1).trim();
            if (keyword.length === 0) {
                setSuggestions([]);
                return;
            }

            try {
                const res = await apiGetTagStat(keyword);
                const tagData =
                    _optionalChain([res, 'optionalAccess', _ => _.data, 'optionalAccess', _2 => _2.map, 'call', _3 => _3((tagItem) => ({
                        ...tagItem,
                        __type: "tag",
                    }))]) || [];
                setSuggestions(tagData);
            } catch (e) {
                console.error("Error fetching data:", e);
                setSuggestions([]);
            }
            return;
        }

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(async () => {
            try {
                const userRes = await apiGetSearchUser(query);
                const groupRes = await apiGetOwnGroupSocial(query);

                const filtered = [
                    ...(userRes.data || []),
                    ...(groupRes.data || []),
                ].filter((item) => {
                    const firstName = _optionalChain([item, 'access', _4 => _4.first_name, 'optionalAccess', _5 => _5.toLowerCase, 'call', _6 => _6()]) || "";
                    const lastName = _optionalChain([item, 'access', _7 => _7.last_name, 'optionalAccess', _8 => _8.toLowerCase, 'call', _9 => _9()]) || "";
                    const groupName = _optionalChain([item, 'access', _10 => _10.name, 'optionalAccess', _11 => _11.toLowerCase, 'call', _12 => _12()]) || "";
                    const fullName = `${firstName} ${lastName}`;
                    const reversedName = `${lastName} ${firstName}`;
                    return (
                        fullName.includes(query) ||
                        reversedName.includes(query) ||
                        firstName.includes(query) ||
                        lastName.includes(query) ||
                        groupName.includes(query)
                    );
                });

                setSuggestions(filtered);
            } catch (err) {
                console.error(err);
                setSuggestions([]);
            }
        }, 300);
    };

    const itemTemplate = (item) => {
        if (item.__type === "tag") {
            const handleClick = () => {
                const hashtagValue = encodeURIComponent(item.tag);
                window.location.assign(
                    `${process.env.REACT_APP_SOCIAL_URL}/app/hashtag/${hashtagValue}`
                );
            };

            return (
                React.createElement('div', {
                    className: "d-flex flex-column" ,
                    style: { padding: "0.5em", cursor: "pointer" },
                    onClick: handleClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}

                    , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
                        , React.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}, "#", item.tag)
                    )
                    , React.createElement('small', { style: { color: "#888" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
                        , t("search.usageCount", {
                            count: item.usage_count,
                        })
                    )
                )
            );
        }

        const handleClick = () => {
            if (item.first_name) {
                if (item.id === userInfo.id) {
                    window.location.assign(
                        `${process.env.REACT_APP_SOCIAL_URL}/app/profile`
                    );
                } else {
                    window.location.assign(
                        `${process.env.REACT_APP_SOCIAL_URL}/app/profile/${item.id}`
                    );
                }
            } else if (item.register_type === "ORGANIZE") {
                window.location.assign(
                    `${process.env.REACT_APP_SOCIAL_URL}/app/groups/org/${item.id}`
                );
            } else {
                window.location.assign(
                    `${process.env.REACT_APP_SOCIAL_URL}/app/groups/${item.id}`
                );
            }
        };

        return (
            React.createElement('div', {
                className: "d-flex flex-row p-ai-center"  ,
                style: { padding: "0.5em", cursor: "pointer" },
                onClick: handleClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}

                , React.createElement(Image, {
                    src: 
                        item.pic_profile
                            ? `data:image/jpeg;base64,${item.pic_profile}`
                            : item.cover_photo
                            ? `data:image/jpeg;base64,${item.cover_photo}`
                            : "/default_user.png"
                    ,
                    width: 60,
                    height: 60,
                    roundedCircle: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 137}}
                )
                , React.createElement('div', { style: { marginLeft: "0.5em" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
                    , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}
                        , item.first_name || item.name, " " , item.last_name
                    )
                    , React.createElement('small', { style: { color: "#888" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}
                        , item.first_name
                            ? t("search.user")
                            : item.privacy_type
                            ? t("search.group")
                            : ""
                    )
                )
            )
        );
    };

    const getLabel = (item) => {
        if (!item) return "";
        if (item.__type === "tag") return `#${item.tag}`;
        if (item.first_name && item.last_name) {
            return `${item.first_name} ${item.last_name}`;
        }
        if (item.name) return item.name;
        return "";
    };

    return (
        React.createElement('div', { className: `header-search-popup ${className}`.trim(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
            , React.createElement(AutoComplete, {
                value: value,
                suggestions: suggestions,
                completeMethod: search,
                field: (e) => getLabel(e),
                placeholder: t("search.placeholder"),
                itemTemplate: itemTemplate,
                onChange: (e) => setValue(e.value),
                minLength: 1,
                onKeyDown: (e) => {
                    if (e.key === "Enter" && value.startsWith("#")) {
                        const hashtagValue = encodeURIComponent(
                            value.slice(1).trim()
                        );
                        if (hashtagValue) {
                            window.location.assign(
                                `${process.env.REACT_APP_SOCIAL_URL}/app/hashtag/${hashtagValue}`
                            );
                        }
                    }
                }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}
            )
        )
    );
};

export default SearchPopup;
